var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Briefed",
    "data-name": "Icon - Briefed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M17.5,0A17.5,17.5,0,1,1,0,17.5,17.5,17.5,0,0,1,17.5,0Z",
    fill: "#ffe348"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "task_FILL0_wght400_GRAD0_opsz24",
    d: "M166.255-865.6l5.085-5.085-1.305-1.3-3.8,3.8-1.89-1.89L163.06-868.8ZM161.8-862a1.733,1.733,0,0,1-1.271-.529A1.733,1.733,0,0,1,160-863.8v-14.4a1.734,1.734,0,0,1,.529-1.271A1.733,1.733,0,0,1,161.8-880H169l5.4,5.4v10.8a1.733,1.733,0,0,1-.529,1.271A1.733,1.733,0,0,1,172.6-862Zm6.3-11.7v-4.5h-6.3v14.4h10.8v-9.9Zm-6.3-4.5v0Z",
    transform: "translate(-149 889)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.1110ead38038c2d6b88683e2e3e62691.svg";
export { ForwardRef as ReactComponent };